import { render, staticRenderFns } from "./AppDropdown.vue?vue&type=template&id=0879d5d5&scoped=true&"
import script from "./AppDropdown.vue?vue&type=script&lang=js&"
export * from "./AppDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AppDropdown.vue?vue&type=style&index=0&id=0879d5d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879d5d5",
  null
  
)

export default component.exports